import React from "react";
import BannerButton from "entities/bannerButton";
import { Button } from "react-bootstrap";

export function getLinkButton(link?: BannerButton): React.ReactNode {
  return link ? <Button href={link.url}>{link.text}</Button> : undefined;
}
